import { Component, computed, inject, input, signal } from '@angular/core';
import { StateChange } from 'ng-lazyload-image';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-banner',
  standalone: false,
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
})
export class BannerComponent {
  private dataService = inject(DataService);

  // The current super-section's own banner; falls back to the restaurant-wide one.
  sectionBannerUrl = input<string | null | undefined>(null);

  // A banner_url can be set yet point at a deleted image (404) - those are skipped too,
  // so a dead section banner falls back to the restaurant's instead of an empty block.
  private failedUrls = signal<ReadonlySet<string>>(new Set());

  bannerUrl = computed(() => {
    const candidates = [this.sectionBannerUrl(), this.dataService.restaurant().banner_url];
    return candidates.find(url => !!url && !this.failedUrls().has(url)) ?? null;
  });

  onImageStateChange(event: StateChange, url: string): void {
    if (event.reason === 'loading-failed') {
      this.failedUrls.update(failed => new Set(failed).add(url));
    }
  }

  // Restaurant-level action for whichever banner is showing - sections have no action of their own.
  bannerAction(): void {
    const action = this.dataService.restaurant().banner_action;
    if (!action) return;

    const isDirectAction = action.startsWith('tel:') || action.startsWith('mailto:');
    if (isDirectAction) {
      window.location.href = action;
    } else {
      window.open(action);
    }
  }
}
